import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface Props {
  background: string;
}

const useStyles = makeStyles<Theme, Props>((theme) =>
  createStyles({
    container: {
      marginBottom: theme.spacing(4),
      padding: theme.spacing(3),
      background: ({ background }) => background,
      borderRadius: 13,
    },

    textContainer: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-evenly',

      '& h1': {
        color: theme.palette.primary.contrastText,
        fontSize: theme.typography.pxToRem(22),
        fontWeight: theme.typography.fontWeightBold,
      },
    },

    iconContainer: {
      alignItems: 'center',
      justifyContent: 'flex-end',

      '& img': {
        width: '100%',
        height: 'auto',
        maxWidth: 60,
        maxHeight: 70,
      },
    },

    button: {
      marginTop: theme.spacing(1),
      maxWidth: 100,
      color: theme.palette.primary.contrastText,
      textTransform: 'initial',
    },
  })
);

export default useStyles;
